import React, { Component } from "react";

class ZoomNotes extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			
		}
	}
 
	componentDidMount(){
		
	}
	
	closeNotesPop=()=>{
		this.props.updateStateFromChild({openFmsNote: false});
	}
	
	chooseNote=(mod)=>{
		this.props.updateStateFromChild({choosenNoteNum: mod});
	}
	
	render() {
		return (
			
				<div className="stream_inner_pop notes_back_color">
					<div className="notesH1" >Feedback</div>
					<div className="closeNotesBtn" onClick={this.closeNotesPop}></div>
					<div className="noteHolderPart" >
						<div className="noteImgMax" style={{backgroundImage: "url('" + this.props.state.participantNotes[this.props.state.choosenNoteNum]['file'] + "')"}} ></div>
						<div className="notesHolderVertical" >
							<div className="notesVertical" style={{width: this.props.state.participantNotes.length * 110+'px'}} >	
								{ this.props.state.participantNotes.map((item, i) =>
									<div className={"noteOptionMax " + ( i == this.props.state.choosenNoteNum ? "activeNoteText" : "" ) } key={i} onClick={(e) => this.chooseNote(i)} > Note {i+1}</div>
								)}
							</div>
						</div>
						<div className="noteTextMax" >{this.props.state.participantNotes[this.props.state.choosenNoteNum]['note']}</div>
					</div>
				</div>

	)}
}
export default ZoomNotes;
